import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { registerPostHogProperties } from '../../services/postHogService';

// `display: contents` keeps the wrapper out of the layout tree so it can't
// affect flex/grid parents. The data-screen attr is picked up by PostHog
// autocapture, which walks up the DOM collecting attributes on clicked elements.
const WRAPPER_STYLE = { display: 'contents' };

function Screen({ name, children }) {
  useEffect(() => {
    registerPostHogProperties({ screen: name });
  }, [name]);

  return (
    <div data-screen={name} style={WRAPPER_STYLE}>
      {children}
    </div>
  );
}

Screen.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.node
};

export default Screen;
